//@flow
import at from 'lodash/at';
import forEach from 'lodash/forEach';
import SpreadSheetExporter from 'common/utils/xlsxExporter';

export default class FileUtils {
    static download({ blob, fileName = 'test.txt', url }) {
        const blobUrl = blob ? URL.createObjectURL(blob) : url;
        if (navigator.msSaveBlob && blob) {
            // IE 10+
            navigator.msSaveBlob(blob, fileName);
        } else {
            var link = document.createElement('a');
            if (link.download !== undefined) {
                // feature detection
                // Browsers that support HTML5 download attribute
                link.setAttribute('href', blobUrl);
                link.setAttribute('download', fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    static createCSVBlob({ sheetName, headers, rows }) {
        const exporter = new SpreadSheetExporter([], sheetName);

        exporter.twoDimensionalArrayBuilder(headers);
        forEach(rows, row => {
            exporter.twoDimensionalArrayBuilder(at(row, headers));
        });
        // Chrome only supports 2million characters in the href so data.uri manner of export doesn't work.
        // So we change this to export using blob
        return exporter.getCSVDataBlob();
    }

    static createAndDownloadCSV({ sheetName, headers, rows, fileName }) {
        const blob = FileUtils.createCSVBlob({
            sheetName,
            headers,
            rows
        });
        FileUtils.download({ blob, fileName });
    }
}
